import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {Body} from "@khanacademy/wonder-blocks-typography";

export default function TableHeaderNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <Body {...attributes} style={styles.thead} tag="thead">
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    thead: {
        display: "table-header-group",
    },
});
